import React, { useContext, useEffect, useState } from "react";
import {
  Grid,
  Avatar,
  Typography,
  makeStyles,
  Link,
  Card,
  CardContent,
  CardMedia,
} from "@material-ui/core";
import { ApptContext, ProviderSchedule, Slots } from "../../../../../../store";
import useStyles from "../../../../../../css/styles_PE";
import { formatphone } from "../../../../../../api/PE_API";
import SlotsContainer from "../Components/SlotsContainer";
import { GetAdminSettingValue, InsertPPLogs } from "../../../../../../api";//FB 8024

// Update log
// FB  6192   02/06/2023  DK  To display the Weekly slots for the Provider
// FB  7413   09/25/2023  GA  Orady - Update the map link to the correct one
// FB  8024   01/03/2023  SK  Including Recent Patient Engagement Enhancements to Patient Portal
// FB  8214   02/01/2024  SK  Accept Case Sensitive Admin Setting Value for Enable PE Custom Appointments in API and Portal and PE


interface IProviderScheduleRowProps {
  ProviderSchedules: ProviderSchedule[];
  Limited: number;
  Index: number;
  ProviderId: number;
  ProviderName: string;
  isLoading: any;
}

const Styles = makeStyles((theme) => ({
  timeSlotItem: {
    borderRadius: "16px",
    border: "0",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#EDEEEE",
    padding: "10px",
    fontSize: "smaller",
  },
}));

export default function ProviderSlots(props: IProviderScheduleRowProps) {
  const classes = Styles();
  const styles = useStyles();
  const { state, dispatch } = useContext(ApptContext);
  let Phone = props.ProviderSchedules[props.Index].Scheduling_Phone;
  if (Phone != null) {
    Phone = Phone.replace(/[^0-9]/g, "");
  }
  const [disableEvents, setDiableEvents] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  let patientName = "User";
  let userName: any;
  let data = sessionStorage.getItem("user");
  if (data != null) {
    patientName = JSON.parse(data).PatientFirstName;
    userName = JSON.parse(data).Login;
  }
  const insertLogs = async () => {
    InsertPPLogs("Click on View Map", window.location.href, userName, "");
  };
  useEffect(() => {
    props.isLoading(isLoading);
  }, [isLoading]);
  //FB 8024 - Begin
  const [customAppointment, setCustomAppointment] = useState("");
  async function fetchCustomAppointmentDetails() {
    const customApptAdmin = (await GetAdminSettingValue("Enable PE Custom Appointments"))[0].toLowerCase();//FB 8214
    if (customApptAdmin == "true") {
      let data = sessionStorage.getItem("AppointmentType");
      if (data != null) {
        setCustomAppointment(data);
      }
    }
  }
  useEffect(() => {
    fetchCustomAppointmentDetails();
  }, []);
  //FB 8024 - End

  return props.ProviderSchedules !== undefined ? (
    <div>
      {window.innerWidth <= 768 ? (
        <div>
          <Grid
            container
            spacing={3}
            direction="row"
            alignContent="center"
            justify="center"
          >
            <Grid item xs={12}>
              <Card
                className={styles.slotslocation_Card}
                style={{ boxShadow: "none" }}
              >
                <CardMedia>
                  <Avatar
                    style={{ marginTop: 5 }}
                    className={styles.slotslocation_Avatar}
                    src={
                      "/Images/Locations/" +
                      props.ProviderSchedules[props.Index].Facility_N +
                      ".jpg"
                    }
                  />
                </CardMedia>
                <CardContent>
                  <Typography variant="h6">
                    <b>{props.ProviderSchedules[props.Index].Facility_Name}</b>
                  </Typography>
                  <Typography style={{ fontSize: "medium" }}>
                    {props.ProviderSchedules[props.Index].Facility_Address}
                  </Typography>
                  <Typography style={{ fontSize: "medium" }}>
                    {props.ProviderSchedules[props.Index].Facility_Info}
                  </Typography>
                  <Typography
                    style={{
                      fontSize: "medium",
                      display: "flex",
                      alignContent: "center",
                    }}
                  >
                    {/*FB-4930*/}
                    {formatphone(
                      props.ProviderSchedules[props.Index].Scheduling_Phone
                    )}
                  </Typography>
                  <Typography
                    style={{
                      display:
                        state.AppointmentType === "telederm" ||
                          props.ProviderSchedules[props.Index]
                            .Facility_Address === "" ||
                          props.ProviderSchedules[props.Index]
                            .Facility_Address === null
                          ? "none"
                          : "flex",
                    }}
                  >
                    <Link
                      href={
                        props.ProviderSchedules[props.Index].GOOGLE_MAPS_LINK

                      } //FB 7413
                      //onClick={insertLogs}
                      target="_blank"
                    >
                      View Map
                    </Link>
                  </Typography>
                  {/* FB 8024 - Begin */}
                  <Typography>
                    {customAppointment && (
                      <>
                        {customAppointment}
                      </>
                    )}
                  </Typography>
                  {/* FB 8024 - End */}
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={3}
            direction="row"
            alignContent="center"
            justify="center"
            style={{
              display: "flex",
              pointerEvents: disableEvents ? "none" : "auto",
            }}
          >
            {props.ProviderSchedules[props.Index].SlotsDate.length === 1 ? (
              <Grid
                item
                xs={10}
                style={{ backgroundColor: "lightgray", borderRadius: "16px" }}
              >
                <Typography variant="subtitle2" style={{ textAlign: "center" }}>
                  The next available online appointment for this provider is{" "}
                  {props.ProviderSchedules[props.Index].NextAvailability}. If
                  you need an appointment sooner, Please call{" "}
                  {formatphone(
                    props.ProviderSchedules[props.Index].Scheduling_Phone
                  )}
                  .
                </Typography>
              </Grid>
            ) : props.ProviderSchedules[props.Index].AvailableSlotsCount <=
              0 ? (
              <Grid
                item
                xs={10}
                style={{ backgroundColor: "lightgray", borderRadius: "16px" }}
              >
                {props.ProviderSchedules[props.Index].NextAvailability !=
                  null ? (
                  <Typography
                    variant="subtitle2"
                    style={{ textAlign: "center" }}
                  >
                    The next available online appointment for this provider is{" "}
                    {props.ProviderSchedules[props.Index].NextAvailability}. If
                    you need an appointment sooner, Please call{" "}
                    {formatphone(
                      props.ProviderSchedules[props.Index].Scheduling_Phone
                    )}
                    .
                  </Typography>
                ) : (
                  <Typography
                    variant="subtitle2"
                    style={{ textAlign: "center" }}
                  >
                    There are no online appointments available for this
                    provider. Please call{" "}
                    {formatphone(
                      props.ProviderSchedules[props.Index].Scheduling_Phone
                    )}{" "}
                    to book an appointment.
                  </Typography>
                )}
              </Grid>
            ) : (
              <Grid item xs={10} style={{ overflowX: "auto" }}>
                {props.ProviderSchedules[props.Index].SlotsDate.map(
                  (ele: Slots, index: number) => (
                    <SlotsContainer
                      limited={props.Limited}
                      schedulesTest={ele}
                      key={index}
                      facilityid={
                        props.ProviderSchedules[props.Index].Facility_N
                      }
                      employeeid={props.ProviderId}
                      employeeName={props.ProviderName}
                      facilityName={
                        props.ProviderSchedules[props.Index].Facility_Name
                      }
                      facilityAddress={
                        props.ProviderSchedules[props.Index].Facility_Address +
                        ", " +
                        props.ProviderSchedules[props.Index].Facility_Info
                      }
                      facilityPhone={
                        Phone != null
                          ? "(" +
                          Phone.slice(0, 3) +
                          ") " +
                          Phone.slice(3, 6) +
                          "-" +
                          Phone.slice(6, 10)
                          : ""
                      }
                      onCallback={setDiableEvents}
                      isLoading={setIsLoading}
                      duration={props.ProviderSchedules[props.Index].Duration}
                    />
                  )
                )}
              </Grid>
            )}
          </Grid>
        </div>
      ) : (
        <Grid
          container
          spacing={3}
          direction="row"
          alignContent="center"
          justify="flex-start"
          style={{ borderBottom: "1px solid rgb(0 0 0 / 25%)", marginTop: 10 }}
        >
          <Grid item xs={4} sm={4} md={4}>
            <Card
              className={styles.slotslocation_Card}
              style={{ boxShadow: "none", alignItems: "center" }}
            >
              <CardMedia>
                <Avatar
                  style={{ marginTop: 5 }}
                  className={styles.slotslocation_Avatar}
                  src={
                    "/Images/Locations/" +
                    props.ProviderSchedules[props.Index].Facility_N +
                    ".jpg"
                  }
                />
              </CardMedia>
              <CardContent style={{ display: "contents" }}>
                <Typography variant="h6">
                  <b>{props.ProviderSchedules[props.Index].Facility_Name}</b>
                </Typography>
                <Typography style={{ fontSize: "medium" }}>
                  {props.ProviderSchedules[props.Index].Facility_Address}
                </Typography>
                <Typography style={{ fontSize: "medium" }}>
                  {props.ProviderSchedules[props.Index].Facility_Info}
                </Typography>
                <Typography style={{ fontSize: "medium" }}>
                  {formatphone(
                    props.ProviderSchedules[props.Index].Scheduling_Phone
                  )}
                </Typography>
                <Typography
                  style={{
                    display:
                      state.AppointmentType === "telederm" ||
                        props.ProviderSchedules[props.Index].Facility_Address ===
                        "" ||
                        props.ProviderSchedules[props.Index].Facility_Address ===
                        null
                        ? "none"
                        : "flex",
                  }}
                >
                  <Link
                    href={
                      props.ProviderSchedules[props.Index].GOOGLE_MAPS_LINK
                    }//FB 7413
                    //onClick={insertLogs}
                    target="_blank"
                  >
                    View Map
                  </Link>
                </Typography>
                {/* FB 8024 - Begin */}
                <Typography>
                  {customAppointment && (
                    <>
                      {customAppointment}
                    </>
                  )}
                </Typography>
                {/* FB 8024 - End */}
              </CardContent>
            </Card>
          </Grid>
          <Grid
            item
            xs={6}
            sm={7}
            md={7}
            style={{
              display: "flex",
              pointerEvents: disableEvents ? "none" : "auto",
            }}
            direction="row"
            alignContent="space-around"
            justify="space-around"
          >
            {props.ProviderSchedules[props.Index].SlotsDate.length === 1 ? (
              <Grid item style={{ margin: "auto" }}>
                <Grid
                  container
                  direction="column"
                  justify="center"
                  alignItems="center"
                >
                  <div className={classes.timeSlotItem}>
                    <Typography
                      variant="subtitle2"
                      style={{ textAlign: "center" }}
                    >
                      The next available online appointment for this provider is{" "}
                      {props.ProviderSchedules[props.Index].NextAvailability}.
                      If you need an appointment sooner, Please call{" "}
                      {formatphone(
                        props.ProviderSchedules[props.Index].Scheduling_Phone
                      )}{" "}
                      .
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            ) : props.ProviderSchedules[props.Index].AvailableSlotsCount <=
              0 ? (
              <Grid item style={{ margin: "auto" }}>
                <Grid
                  container
                  direction="column"
                  justify="center"
                  alignItems="center"
                >
                  {props.ProviderSchedules[props.Index].NextAvailability !=
                    null ? (
                    <div className={classes.timeSlotItem}>
                      <Typography
                        variant="subtitle2"
                        style={{ textAlign: "center" }}
                      >
                        The next available online appointment for this provider
                        is{" "}
                        {props.ProviderSchedules[props.Index].NextAvailability}.
                        If you need an appointment sooner, Please call{" "}
                        {formatphone(
                          props.ProviderSchedules[props.Index].Scheduling_Phone
                        )}
                        .
                      </Typography>
                    </div>
                  ) : (
                    <div className={classes.timeSlotItem}>
                      <Typography
                        variant="subtitle2"
                        style={{ textAlign: "center" }}
                      >
                        There are no online appointments available for this
                        provider. Please call{" "}
                        {formatphone(
                          props.ProviderSchedules[props.Index].Scheduling_Phone
                        )}{" "}
                        to book an appointment.
                      </Typography>
                    </div>
                  )}
                </Grid>
              </Grid>
            ) : (
              props.ProviderSchedules[props.Index].SlotsDate.map(
                (ele: Slots, index: number) => (
                  <SlotsContainer
                    limited={props.Limited}
                    schedulesTest={ele}
                    key={index}
                    facilityid={props.ProviderSchedules[props.Index].Facility_N}
                    employeeid={props.ProviderId}
                    employeeName={props.ProviderName}
                    facilityName={
                      props.ProviderSchedules[props.Index].Facility_Name
                    }
                    facilityAddress={
                      props.ProviderSchedules[props.Index].Facility_Address +
                      ", " +
                      props.ProviderSchedules[props.Index].Facility_Info
                    }
                    facilityPhone={
                      Phone != null
                        ? "(" +
                        Phone.slice(0, 3) +
                        ") " +
                        Phone.slice(3, 6) +
                        "-" +
                        Phone.slice(6, 10)
                        : ""
                    }
                    onCallback={setDiableEvents}
                    isLoading={setIsLoading}
                    duration={props.ProviderSchedules[props.Index].Duration}
                  />
                )
              )
            )}
          </Grid>
        </Grid>
      )}
    </div>
  ) : (
    <></>
  );
}
